import Vue from 'vue';
import Router from 'vue-router';

import { getUser } from './utils/storageUtil';

import Index from './views/Index.vue';
import Login from './views/login/Index.vue';
import Agreement from './views/login/Agreement.vue'
import Forget from './views/login/Forget.vue';
import TagManage from './views/tag/TagManage.vue';
import Discover from './views/discover/Discover2.vue';
import Filtered from './views/discover/Filtered.vue';
import Search from './views/discover/Search.vue';
import Digital from './views/digital/Digital.vue';
import DigitalGeneral from './views/digital/DigitalGeneral.vue';
import DigitalDetail from './views/digital/DigitalDetail.vue';
import Vip from './views/vip/Index.vue';
import UserCenter from './views/vip/UserCenter.vue';
import College from './views/college/College.vue';
import CourseDetail from './views/college/CourseDetail.vue';
import PdfViewer from './views/college/PdfViewer.vue';
import News from './views/news/News.vue';
import NewsDetail from './views/news/NewsDetail.vue';
import My from './views/my/My.vue';
import MyIndex from './views/my/Index.vue';
import Feedback from './views/my/Feedback.vue';
import About from './views/my/About.vue';
import Setting from './views/my/Setting.vue';
import Message from './views/my/Message.vue';
import Following from './views/my/Following.vue';
import Wallet from './views/my/Wallet.vue';
import History from './views/my/History.vue';
import Transaction from './views/my/Transaction.vue';
import Order from './views/my/Order.vue';
import Open from './views/my/Open.vue';
import Favorite from './views/my/Favorite.vue';
import Achievement from './views/my/Achievement.vue';
import Learning from './views/my/Learning.vue';
import Edit from './views/my/Edit.vue';
import ChangePass from './views/my/ChangePass';
import Wechat from './views/login/Wechat';
import Share from './views/my/Share';
import PrivacyPolicy from './views/my/PrivacyPolicy';
import Data from './views/data/Data.vue'; //数据  foot iteam
import DataDetail from './views/data/DataDetail.vue'; //数据明细
import DataList from './views/data/DataList.vue'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
Vue.use(Router);
const scrollBehavior = (to, from, savedPosition) => {
  return { x: 0, y: 0 }
}

const router = new Router({
  // mode:'history',
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          redirect: '/discover'
        },
        {
          path: '/login', // 登录
          name: 'login',
          component: Login
        },
        {
          path: '/wechat', // 微信绑定手机号
          name: 'wechat',
          component: Wechat
        },
        {
          path: '/share',
          name: 'share',
          component: Share,
          meta:{
            requireToken: false
          }
        },
        {
          path: '/forget', // 忘记密码
          name: 'forget',
          component: Forget
        },
        {
          path: '/agreement',
          name: 'agreement',
          component: Agreement
        },
        {
          path: '/tagManage', // 频道管理
          name: 'tagManage',
          component: TagManage
        },
        {
          path: '/discover', // 发现
          name: 'discover',
          component: Discover
        },
        {
          path: '/filtered', // tag筛选
          name: 'filtered',
          component: Filtered
        },
        {
          path: '/search', // 搜索结果
          name: 'search',
          component: Search
        },
        {
          path: '/data', // footbar  item  数据
          name: 'data',
          component: Data
        },
        {
          path: '/dataDetail', // footbar  item  数据
          name: 'dataDetail',
          component: DataDetail
        },
        {
          path: '/dataList', // footbar  item  数据
          name: 'dataList',
          component: DataList
        },
        {
          path: '/digital', // 智库
          name: 'digital',
          component: Digital
        },
        {
          path: '/digitalGeneral', // 智库概述
          name: 'digitalGeneral',
          component: DigitalGeneral
        },
        {
          path: '/digitalDetail', // 智库详情
          name: 'digitalDetail',
          component: DigitalDetail,
         
        },

        {
          path: '/college', // 学院
          name: 'college',
          component: College
        },
        {
          path: '/courseDetail', // 课程详情
          name: 'courseDetail',
          component: CourseDetail,
        },
        {
          path: '/pdfViewer',
          name: 'pdfViewer',
          component: PdfViewer,
          meta: {
            requireToken: true
          }
        },
        {
          path: '/vip', // VIP
          name: 'vip',
          component: Vip,
          meta: {
            requireToken: false
          }
        },
        {
          path: '/news', // 新闻列表
          name: 'news',
          component: News
        },
        {
          path: '/newsDetail', // 新闻详情
          name: 'newsDetail',
          component: NewsDetail,
        },
        {
          path: '/userCenter', // 用户中心
          name: 'userCenter',
          component: UserCenter
        },
        {
          path: '/open',
          name: 'open',
          component: Open
        },
        {
          path: '/about',
          name: 'about',
          component: About
        },
        {
          path: '/my',
          name: 'my',
          component: My,
          meta: {
            requireToken: true
          },
          children: [
            {
              path: '/',
              name: 'myIndex',
              component: MyIndex
            },
            {
              path: 'following', // 关注
              name: 'following',
              component: Following
            },
            {
              path: 'feedback', // 意见反馈
              name: 'feedback',
              component: Feedback
            },
            {
              path: 'setting', // 安全设置
              name: 'setting',
              component: Setting
            },
            {
              path: 'message', // 通知
              name: 'message',
              component: Message
            },
            {
              path: 'wallet', // 钱包
              name: 'wallet',
              component: Wallet
            },
            {
              path: 'history', // 最近阅读
              name: 'history',
              component: History
            },
            {
              path: 'transaction', // 友绿币交易记录
              name: 'transaction',
              component: Transaction
            },
            {
              path: 'order', 
              name: 'order',
              component: Order
            },
            {
              path: 'achievement',
              name: 'achievement',
              component: Achievement
            },
            {
              path: 'learning',
              name: 'learning',
              component: Learning
            },
            {
              path: 'favorite',
              name: 'favorite',
              component: Favorite
            },
            {
              path: 'edit',
              name: 'edit',
              component: Edit
            },
            {
              path: 'changePass',
              name: 'changePass',
              component: ChangePass
            },
            {
              path: 'privacyPolicy',
              name: 'privacyPolicy',
              component: PrivacyPolicy
            }
          ]
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(rec => rec.meta.requireToken)) {
    const user = getUser();
    if (user && user.token) {
      next();
    } else {
      next({
        path: '/login'
      });
    }
  } else {
    next();
  }
});

export default router;
